import { useState } from 'react';
import DotDotDotMenu from '~/components/DotDotDotMenu';
import CopyIcon from '~/components/icons/CopyIcon';
import DownloadIcon from '~/components/icons/DownloadIcon';
import useBusinessPostApi from '~/lib/useBusinessPostApi';
import useBusinessNavigate from '~/lib/useBusinessNavigate';
import { businessApiRoute, get } from '~/lib/Api';
import * as Toast from '~/lib/Toast';

const InvoiceRowMenu = ({ invoice, refetch }) => {
    const navigate = useBusinessNavigate();
    const [deletingId, setDeletingId] = useState(null);
    const [duplicatingId, setDuplicatingId] = useState(null);
    const [isDownloading, setIsDownloading] = useState(false);

    const { save: deletePost, isSaving: isDeleting } = useBusinessPostApi(`/invoices/${invoice.id}/delete`);
    const { save: duplicatePost, isSaving: isDuplicating } = useBusinessPostApi(`/invoices/${invoice.id}/duplicate`);

    const handleDelete = async (e) => {
        e?.stopPropagation();

        if (!confirm(`Are you sure you want to delete Invoice #${invoice.invoice_number}?`)) {
            return;
        }

        setDeletingId(invoice.id);
        try {
            await deletePost({});
            Toast.success('Invoice deleted successfully');
            refetch?.();
        } catch (error) {
            Toast.error('Failed to delete invoice');
        } finally {
            setDeletingId(null);
        }
    };

    const handleDuplicate = async (e) => {
        e?.stopPropagation();

        setDuplicatingId(invoice.id);
        try {
            const result = await duplicatePost({});
            Toast.success('Invoice duplicated successfully');
            refetch?.();
            // Navigate to the new invoice
            if (result.invoice_id) {
                navigate(`/invoices/${result.invoice_id}`);
            }
        } catch (error) {
            console.log(error)
            Toast.error('Failed to duplicate invoice');
        } finally {
            setDuplicatingId(null);
        }
    };

    const handleDownloadPdf = async (e) => {
        e?.stopPropagation();
        setIsDownloading(true);
        try {
            const blob = await get(businessApiRoute(`/invoices/${invoice.id}/pdf`), {}, { responseType: 'blob' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `invoice-${invoice.invoice_number || invoice.id}.pdf`;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            Toast.error('Failed to download invoice PDF');
        } finally {
            setIsDownloading(false);
        }
    };

    const isPaid = invoice.status === 'paid';

    const menuOptions = [
        {
            name: isDownloading ? 'Downloading...' : 'Download PDF',
            icon: <DownloadIcon />,
            onClick: handleDownloadPdf,
        },
        {
            name: isDuplicating ? 'Duplicating...' : 'Duplicate',
            icon: <CopyIcon />,
            onClick: handleDuplicate,
        },
    ];

    // Only allow deletion if invoice is not paid
    if (!isPaid) {
        menuOptions.push({
            name: isDeleting ? 'Deleting...' : 'Delete',
            isDelete: true,
            onClick: handleDelete,
        });
    }

    return (
        <div onClick={(e) => e.stopPropagation()}>
            <DotDotDotMenu options={menuOptions} />
        </div>
    );
};

export default InvoiceRowMenu;

